const config = {
    price_per_guest: 15,
    minimum_price: 30,
    hourUntilOrderAvailable: 7,
    // api_url: 'http://boheme.test/api/',
    // login_url: 'http://boheme.test/login',
    api_url: 'https://service-test.bohemehouse.lt/api/',
    login_url: 'https://service-test.bohemehouse.lt/login',
    // api_url: 'https://service.bohemehouse.lt/api/',
    // login_url: 'https://service.bohemehouse.lt/login',
    // telegramEndpoint: 'https://api.telegram.org/bot6103888231:AAFzy8FB9daBPAVFgI21JW0SDtqgKTyp1xM/sendMessage',
    chatId: "-995447073",
};

export default config;
